import { render, staticRenderFns } from "./ContactAttributesOnClientDialog.vue?vue&type=template&id=37c582f3&scoped=true&"
import script from "./ContactAttributesOnClientDialog.vue?vue&type=script&lang=js&"
export * from "./ContactAttributesOnClientDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContactAttributesOnClientDialog.vue?vue&type=style&index=0&id=37c582f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c582f3",
  null
  
)

export default component.exports